import { FieldProps } from 'formik';
import * as React from 'react';
import styled from 'styled-components';
import { Box, StyledInput, Dropzone, Flex } from '../';
import { isMobile, isTablet } from '../../../utils';
import { StyledSystemProps } from '../../../theme/StyledSystemProps';
import { Label } from '../../../typography';

type FormGroupProps = FieldProps &
  StyledSystemProps & {
    color?: string;
    defaultChecked?: boolean;
    disabled?: boolean;
    label?: string;
    placeholder?: string;
    readOnly?: boolean;
    step?: string;
    type: string;
    value?: string | number;
    onChange?: (option: any) => void;
    anchorText?: string;
    anchorOnClick?: () => void;
  };

const LabelAnchor = styled('a')`
  color: #9cbc2c;
`;
class FormGroup extends React.Component<FormGroupProps, {}> {
  static defaultProps = {
    mb: 3,
    width: '100%',
    type: 'string',
    flex: 1,
    minWidth: '150px',
  };

  clickedAnchorLabel = (e: any, anchorClick?: () => void) => {
    e.preventDefault();
    if (anchorClick) {
      anchorClick();
    }
  };

  render() {
    const {
      field,
      form,
      label,
      type,
      step,
      disabled,
      placeholder,
      readOnly,
      value,
      anchorText,
      anchorOnClick,
    } = this.props;
    const isMobileCheckbox = (isMobile || isTablet) && type === 'checkbox';
    return (
      <Box
        {...this.props}
        flexDirection={isMobileCheckbox ? 'row' : 'column'}
        {...(isMobileCheckbox && { justifyContent: 'space-between' })}
      >
        <Flex direction="row" size="1" justify="space-between">
          <Label htmlFor={field.name}>{label}</Label>
          <LabelAnchor href="#" onClick={e => this.clickedAnchorLabel(e, anchorOnClick)}>
            {anchorText}
          </LabelAnchor>
        </Flex>

        {type === 'file' ? (
          <Dropzone id={field.name} name={field.name} form={form} />
        ) : (
          <StyledInput
            disabled={disabled}
            type={type}
            id={field.name}
            px={2}
            {...field}
            placeholder={placeholder}
            defaultChecked={this.props.defaultChecked}
            onChange={this.props.onChange}
            readOnly={readOnly}
            value={value}
            step={step}
            wrapperWidth={isMobileCheckbox ? '20px' : ''}
          />
        )}
        {/* <ErrorMessage name={field.name}>
          {msg => (
            <Span mt={2} color="error" textAlign="right">
              {msg}
            </Span>
          )}
        </ErrorMessage> */}
      </Box>
    );
  }
}

export default FormGroup;
